import {initializeSelect2} from '../../helpers/select2_helper'

document.addEventListener('DOMContentLoaded', () => {
  if ($('#tenants-edit').length > 0) {
    initializeSelect2('#tenant_feed_ids', true)
  }
})
